var interf = {
    current:"topview",
    seatmap:{
        nodes_selected: []
    },
    topview:{
        nodes_selected: [],
        hash:{}
    },
    filtering:{
        ref : null,
        nodes : {
            sections: [],
            rows: [],
            seats: []
        }
    },
    navigation:{
        to: "",
        from: ""
    },
    window:{
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
        animation: requestAnimationFrame(interfaceWindowLoop)
    },
    params:interfaceGetParams(window.location.href)
}

function interfaceIsMobile(){
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || $(window).width()<620) {
        return true;
    } else {
        return false;
    }
}

function interfaceGetParams(url) {
	var params = {};
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
    if(params.v360){
        params.v360 = atob(params.v360)
    }
    if(params.search){
        params.search = atob(params.search)
    }
	return params;
};


function interfaceMoveArrowsHideOnLimits(){
    if(viewer.limits) {
        if(viewer.limits.left_limit) {
            $("#move-left").addClass("hidden");
        }
        
        if(viewer.limits.right_limit) {
            $("#move-right").addClass("hidden");
        }
        
        if(viewer.limits.upper_limit) {
            $("#move-up").addClass("hidden");
        }
        
        if(viewer.limits.lower_limit) {
            $("#move-down").addClass("hidden");
        }
    }
    return null;
}

function interfaceMoveArrowsShow(){
    $("#move-up").removeClass("hidden");
    $("#move-down").removeClass("hidden");
    $("#move-left").removeClass("hidden");
    $("#move-right").removeClass("hidden");
    return null;
}
function interfaceMoveArrowsHide(){
    $("#move-up").addClass("hidden");
    $("#move-down").addClass("hidden");
    $("#move-left").addClass("hidden");
    $("#move-right").addClass("hidden");
    return null;
}

function interfaceReset(){
    interf = {
        current:"topview",
        seatmap:{
            nodes_selected: []
        },
        topview:{
            nodes_selected: []
        },
        filtering:{
            ref : null,
            nodes : {
                sections: [],
                rows: [],
                seats: []
            }
        },
        navigation:{
            to: "",
            from: ""
        },
        window:{
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight,
            animation: requestAnimationFrame(interfaceWindowLoop)
        }
    }
}
function interfaceResetFiltering(){
    interf.filtering = {
            ref : null,
            nodes : {
                sections: [],
                rows: [],
                seats: []
            }
        }
}

function interfaceWindowLoop() {
    
    var h = window.innerHeight;
    var bh = h - ($("#header-wrap").innerHeight() + $("#topbar").innerHeight() + $(".app-topbar.sub").innerHeight());
    if(interfaceIsMobile()){
        bh = window.innerHeight - ($("#interface-btns-mobile").innerHeight() +
        $("#header-wrap").innerHeight() + $("#topbar").innerHeight());
    }
    $("#main-interface").css("height", bh);
    interf.window.animation = requestAnimationFrame(interfaceWindowLoop);

    if(viewer && viewer.isLoaded()){
        if(interfaceIsMobile()){
            dvmHideLabs();
            $("#interface-btns-mobile").removeClass("hidden");
            $(".interface-btns-desktop").addClass("hidden");
            $(".nav-section-text").addClass("hidden");
        }else{
            $("#interface-btns-mobile").addClass("hidden");
            $(".interface-btns-desktop").removeClass("hidden");
            $(".nav-section-text").removeClass("hidden");
            dvmShowLabs();
        }

        if(interfaceGetCurrent()!='view3d'){
            breadcrumbsShowToggle();
        }

        if(!interfaceIsMobile() && viewer.scaling_factor > viewer.min_scaling_factor && interf.current != "view3d") {
            interfaceMoveArrowsShow()
        } else {
            interfaceMoveArrowsHide()
        }
        interfaceMoveArrowsHideOnLimits();
        if(viewer.getMapId()=='blockmap'){
            menuBtnShow();
        }else{
            menuBtnHide();
        }
    }
}

function interfaceZoomHide(){
    $(".zoom-in-btn").addClass("hidden");
    $(".zoom-out-btn").addClass("hidden");
    return;
}

function interfaceZoomShow(){
    //if(!interfaceIsMobile()){
        $(".zoom-in-btn").removeClass("hidden");
        $(".zoom-out-btn").removeClass("hidden");
    //}
    return;
}

function interfaceMoveFSbtn(){
    if(interfaceIsMobile()){
        viewer_3d.interface.setInterfaceElementPosition("toggle-fullscreen","bottomcenter")
    }
    return;
}

function interfaceFSBtnShow(){
    $(".fs-btn").removeClass("hidden");
    return null;
}

function interfaceFSBtnHide(){
    $(".fs-btn").addClass("hidden");
    return null;
}

function interfaceHomeBtnShow(){
    if(!interf.params.v360){
        $(".home-btn").removeClass("hidden");
    }
    return null;
}
function interfaceHomeBtnHide(){
    $(".home-btn").addClass("hidden");
    return null;
}
function interfaceGalleryArrowsToggle(){
    $(".glide__arrow").removeClass("hidden");
    if(interfaceIsMobile()){
        $(".glide__arrow").addClass("hidden");
    }
    return null;
}

function interfaceSetCurrent(current){
    interf.current = current;
    return interf;
}

function interfaceGetCurrent(){
    return interf.current;
}

function interfaceViewer3DBtnsHide(){
    $(".viewer-btn").addClass("hidden");
    return null;
}

function interfaceBackBtnShow(){
    if(!interf.params.v360){
        $(".back-btn").removeClass("hidden");
    }
    return null;
}
function interfaceBackBtnHide(){
    $(".back-btn").addClass("hidden");
    return null;
}

// SHARE
function interfaceShowShareBtn(){
    if(!interf.params.v360){
       $(".share-btn").removeClass("hidden");
    }
    return null;
}
function interfaceLinkToShare(node){
    let link = window.location.href.split('?')[0];
    //let link = "local.3ddigitalvenue.com:8080";
    if(!node && interf.filtering.ref!='regularseating'){
        link+="?seatingtype=vip";
        if(interf.filtering.ref && interf.filtering.ref!='premiumseating'){
            link+="&search="+btoa(interf.filtering.ref);
        }
    }else if(node){
        link+="?v360="+btoa(node.id);
    }
    // console.log(link)
    $(".linktoshare-input").val(link);
    return;
}
function interfaceCustomModalCopyHide(){
    $(".custom-modal").addClass("hidden");

}
function interfaceShare(){
    $(".custom-modal").toggleClass("hidden");
    $(".share-btn").toggleClass("active");
    if(!$(".custom-modal").hasClass("active")){
        $(".confirmcopy").addClass("hidden")
        $(".linktoshare-input").removeClass("hidden")
        $(".copybtn").removeClass("hidden")
    }else{
        $(".confirmcopy").removeClass("hidden")
        $(".linktoshare-input").addClass("hidden")
        $(".copybtn").addClass("hidden")
    }
}

function interfaceShareSetDefault(){
    $(".custom-modal").addClass("hidden");
    $(".confirmcopy ").addClass("hidden");
    $(".share-btn").removeClass("active");
}

function interfaceHideShareBtn(){
    $(".share-btn").addClass("hidden");
    return null;
}
function copyShareLink(){
    /* Get the text field */
    let copyText = null;
    if(!interfaceIsMobile()){
        copyText = document.getElementById("linktoshare");
    }else{
        copyText = document.getElementById("linktoshare-mbl");
    }
  
    // console.log(copyText);
    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */
  
    /* Copy the text inside the text field */
    document.execCommand("copy");
  
    /* Alert the copied text */
    $(".confirmcopy").removeClass("hidden")
    $(".linktoshare-input").addClass("hidden")
    $(".copybtn").addClass("hidden")
}
// END SHARE
function interfaceGalleryBtnHide(){
    $(".gallery-btn").addClass("hidden");
    return null;
}

function interfaceGalleryBtnShow(){
    $(".gallery-btn").removeClass("hidden");

    return null;
}


function interfaceMinimapHide(){
    $(".minimap").addClass("hidden")
    return null;
}
function interfaceMinimapShow(){
    if(!initialConfig.config.map_id_mini){
        return;
    }
    $(".minimap").removeClass("hidden")
    return null;
}

function interfaceBreadcrumbsValueHide(element){
    $(".bread-crumbs "+element).addClass("hidden");
    return null;
}
function interfaceZoomSetTopview(){
    $(".zoom-btns-interface").addClass("ci-topview");
    $(".zoom-btns-interface").removeClass("ci-seatmap");
    return null;
}
function interfaceZoomSetSeatmap(){
    $(".zoom-btns-interface").removeClass("ci-topview");
    $(".zoom-btns-interface").addClass("ci-seatmap");
    return null;
}
function interfaceSetTopview(){
    viewer_3d.close();
    viewer_3d.reset();
    interfaceViewerShow();
    interfaceViewer3DHide();
    interfaceBackBtnHide();
    interfaceMinimapHide();
    interfaceZoomSetTopview();
    interfaceZoomShow();
    interfaceBreadcrumbsValueHide(".section");
    interfaceBreadcrumbsValueHide(".rows");
    interfaceBreadcrumbsValueHide(".seat");

    interfaceShowShareBtn();
    interfaceHomeBtnHide();
    interfaceFSBtnHide();
    interfaceGalleryBtnHide();
    interfaceNavigationHide();
    menuBtnShow();
    
    interfaceTopbarLeft();

    viewer_mini.scaling_factor = viewer_mini.min_scaling_factor;

    breadcrumbsShowToggle();

    if(interfaceIsMobile()) {
        //interfaceZoomHide();
        interfaceMoveArrowsHide();
        viewer.scaling_factor = 2;
        $("#dropdown-container-mobile").removeClass("hidden");
    } else {
        $("#dropdown-container").removeClass("hidden");
        viewer.scaling_factor = 0.01;
    }
    interfaceTicketsMobileBtnShow();
    popoverDestroyAll();
    interfaceSetCurrent("topview");

}
function interfaceViewerShow(){
    $("#viewer").removeClass("hidden");
    return null;
}
function interfaceViewer3DHide(){
    $("#view3d").addClass("hidden");
    return null;
}

function interfaceSetSeatmap(){
    $("#dropdown-container-mobile").addClass("hidden");
    $("#dropdown-container").addClass("hidden");
    viewer_3d.reset();
    viewer_3d.close();
    interfaceViewerShow();
    interfaceViewer3DHide();
    interfaceViewer3DBtnsHide();
    interfaceGalleryBtnHide();
    interface360BtnHide();
    interfaceHideShareBtn();
    // dvmSeatmapSetStyles();
    if(initialConfig.config.integrationType=='bumper'){
        interfaceBackBtnHide();
    }else{
        interfaceBackBtnShow();
    }
    menuClose();
    menuBtnHide();

    topnavbtnsShow();

    interfaceTopbarCenter();

    interfaceMoveFSbtn();
    interfaceFSBtnHide();
    interfaceHomeBtnHide();
    interfaceZoomSetSeatmap();
    interfaceZoomShow();
    interfaceNavigationHide();
    interfaceMinimapShow();
    if(!interfaceIsMobile()) {
        interfaceHomeBtnHide();
        breadcrumbsShowToggle();
    }
    interfaceTicketsMobileBtnShow();
    interfaceSetCurrent("seatmap");
    return null;
}

function interfacesetViewer3D(node){
    $("#dropdown-container-mobile").addClass("hidden");
    $("#dropdown-container").addClass("hidden");
    interfaceGalleryArrowsToggle();
    $("#viewer").addClass("hidden")
    $("#view3d").removeClass("hidden");
    interfaceSetNodeBC(node);
    interfaceSetCurrent('view3d');
    menuBtnHide();
    interfaceBackBtnShow();
    interfaceShowTopguide();

    interfaceTopbarCenter();
    // interfaceNavigationShow();
    //breadcrumbsHide
    return null;
}

function interfaceGoBack(){
    if (interfaceGetCurrent() === "seatmap") {
        viewer.loadMap({
            venue_id: initialConfig.config.venue_id,
            map_id: initialConfig.config.topview_id
        })    
        .then(onLoadD2MSuccess)
        .catch(onLoadD2MError);

    }  else if (interfaceGetCurrent() === 'view3d') {
        interfaceSetCurrent("seatmap");
        if(interf.seatmap.nodes_selected[0].type=='seat'){
            interfaceSetSeatmap();
        }else{
            interfaceGoBack();
        }
    }
    popoverDestroyAll();
   
}

function interfaceGoHome(){
    if(interf.params.v360){
        return null;
    }
    interfaceSetTopview();
    viewer.loadMap({
        venue_id: initialConfig.config.venue_id,
        map_id: initialConfig.config.topview_id
    })
    .then(onLoadD2MSuccess)
    .catch(onLoadD2MError);
    popoverDestroyAll();
}

function interfaceBCSetColours(){
    for(let type in filtering_typereferenced){
        var ft = filtering_typereferenced[type];
        $("#top-guide").find(".section-lab").removeClass(type);
        $("#top-guide").find(".row-lab").removeClass(type);
        $("#top-guide").find(".seat-lab").removeClass(type);
        for(var i =0;i<ft.length;i++){
            var section_id = ft[i];
            if(interf.topview.nodes_selected.length>0 && interf.topview.nodes_selected[0].id == section_id){
                $(".bread-crumbs").find(".breadcrumbs-val").addClass(type);
                $("#top-guide").find(".section-lab").addClass(type);
                $("#top-guide").find(".row-lab").addClass(type);
                $("#top-guide").find(".seat-lab").addClass(type);
            }
            
        }
       // if(interf.topview.nodes_selected)
    }
}
function interfaceBCResetColours(){
    for(let type in filtering_typereferenced){
        $(".bread-crumbs").find(".breadcrumbs-val").removeClass(type);
        $("#top-guide").find(".section-lab").removeClass(type);
        $("#top-guide").find(".row-lab").removeClass(type);
        $("#top-guide").find(".seat-lab").removeClass(type);
    }
    return null;
}

function interfaceGoViewer(){ 
    interfaceGalleryBtnShow();
    interface360BtnHide();
    interfaceFSBtnShow();
    viewer_3d.gallery.toggleCurrentView();
    interfaceMinimapShow();
    interfaceHomeBtnShow();
    // interfaceNavigationShow();
}
function interface360BtnShow(){
    $(".viewer360-btn").removeClass("hidden");
    return null;
}
function interface360BtnHide(){
    $(".viewer360-btn").addClass("hidden");
    return null;
}

function interfaceGoGallery(){
    interfaceGalleryBtnHide();
    interface360BtnShow();

    interfaceFSBtnHide();
    viewer_3d.gallery.toggleCurrentView();
    interfaceNavigationHide();
    interfaceHomeBtnHide();
    interfaceMinimapHide();
    $(".glide__arrow--right").html("<span class='interface-btn-standard icon-arrow-right'></span>");
    $(".glide__arrow--left").html("<span class='interface-btn-standard icon-arrow-left'></span>");

    return null;
}

function interfaceSetNodeBC(obj) {
    $(".rows").addClass("hidden");
    $(".seat").addClass("hidden");
    $(".section").removeClass("hidden");
    let sectionName = obj.id.split("_")[1].split("-")[0];
    if (translation['S_' + sectionName]) {
        sectionName = translation['S_' + sectionName];
    }
    $(".section-val").text(sectionName);

    var selected_nodes = viewer.getNodesByState("seat","selected");
    if(selected_nodes.length>0){
        var seat_id = selected_nodes[0].id.split("_")[1].split("-");
        $(".rows").removeClass("hidden");
        $(".seat").removeClass("hidden");
        $(".section").removeClass("hidden");
          
        $(".row-val").text(seat_id[1]);
        $(".seat-val").text(seat_id[2]);
    }
    if(interf.filtering.ref && !interfaceIsMobile()){
        $("#top-guide").addClass("filtered");
        $(".section-lab").html("<span class='fa-slash sm-hidden'>/</span> Section");
    }     
}

function interfaceSetTicketsBtn(url,txt){
    //Set link URL
    $(".tickets-link").attr("href",url);
    $("#header-wrap .tickets-link").text(txt);
    return null;
}

function interfaceTicketsMobileBtnHide(){
    $("#interface-btns-mobile .tickets-link").addClass("hidden");
    return null;
}

function interfaceTicketsMobileBtnShow(){
    $("#interface-btns-mobile .tickets-link").removeClass("hidden");
    return null;
}

function interfaceNavigationShow(){
    let current_mapid = viewer.getMapId();
    if(navigation.outdoor[current_mapid]){
        $(".navigation").removeClass("hidden");
    }
}
function interfaceNavigationHide(){
    $(".navigation").addClass("hidden");
}

function interfaceSetNavigationReverse(){
    var aux = interf.navigation.to;
    interf.navigation.to = interf.navigation.from;
    interf.navigation.from  = aux;
    return interf.navigation;
}
function interfaceGetNavigation(){
    return interf.navigation
}

function interfaceSetInitialNavigation(){
    let current_mapid = viewer.getMapId();
    if(navigation.outdoor[current_mapid]){
        let parent = navigation.outdoor[current_mapid];
        let outdoor = parent.node;
        if(!outdoor.title){ outdoor.title = "Acceso sala VIP"; }
        if(!parent.title){ parent.title = "Volver al asiento"; }
        interf.navigation.to = outdoor;
        interf.navigation.from = {id: current_mapid, title:parent.title};

    }
    return interf.navigation
}
function interfaceLangSetSectionRowSeatTxt(){
    var txt = interfaceLangGet();
    $(".section-lab").text(txt.section);
    $(".row-lab").text(txt.row);
    $(".seat-lab").text(txt.seat);
    return null;
}

function interfaceLangGet(){
    var lang_id = initialConfig.config.lang;
    return initialConfig.interface[lang_id];
}    

function interfaceLangSetContent(){
    var lang = interfaceLangGet();
    interfaceSetSectionRowSeatTxt(lang);
}

function interfaceShowTopguide() {
    $("#top-guide").removeClass("hidden");
}

function interfaceHideTopguide() {
    $("#top-guide").addClass("hidden");
}

function interfaceTopbarLeft() {
    $("#interface-wrap .app-topbar").addClass("left");
}

function interfaceTopbarCenter() {
    $("#interface-wrap .app-topbar").removeClass("left");
}